import { BottomSheet, Text, Title, type UseModalState } from "@clipboard-health/ui-components";
import { CircularProgress, DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

interface VideoUploadProgressDialogProps {
  modalState: UseModalState;
  uploadProgress: number | undefined;
  onCancel: () => void;
}

export function VideoUploadProgressDialog(props: VideoUploadProgressDialogProps) {
  const { modalState, uploadProgress, onCancel } = props;

  return (
    <BottomSheet modalState={modalState}>
      <DialogContent sx={{ px: 5, py: 6 }}>
        <Stack spacing={6} alignItems="center">
          <Title variant="h3" component="h3">
            Uploading video
          </Title>
          <Stack spacing={4} alignItems="center">
            <CircularProgress
              variant={uploadProgress === undefined ? "indeterminate" : "determinate"}
              value={uploadProgress === undefined ? undefined : Math.round(uploadProgress * 100)}
              size={60}
              thickness={4}
            />
            <Text bold variant="h4">
              {uploadProgress === undefined
                ? "Uploading..."
                : `${Math.round(uploadProgress * 100)}%`}
            </Text>
            <Button
              startIconType="close"
              variant="destructive"
              size="medium"
              sx={{ mt: 6 }}
              onClick={onCancel}
            >
              Cancel Upload
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
